var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7826 6.70763L8.49238 0.417377C8.22514 0.150137 7.86269 1.97623e-06 7.48476 0H1.425C0.637985 0 0 0.637985 0 1.425V7.48476C1.97623e-06 7.86269 0.150137 8.22514 0.417377 8.49238L6.70763 14.7826C7.26409 15.3391 8.16635 15.3392 8.72287 14.7826L14.7826 8.72287C15.3391 8.16638 15.3391 7.26412 14.7826 6.70763ZM3.325 4.75C2.53799 4.75 1.9 4.11202 1.9 3.325C1.9 2.53799 2.53799 1.9 3.325 1.9C4.11202 1.9 4.75 2.53799 4.75 3.325C4.75 4.11202 4.11202 4.75 3.325 4.75ZM18.5826 8.72287L12.5229 14.7826C11.9664 15.3391 11.0641 15.3391 10.5076 14.7826L10.4969 14.7719L15.6643 9.60456C16.169 9.09991 16.4469 8.42894 16.4469 7.71525C16.4469 7.00156 16.1689 6.33059 15.6643 5.82594L9.83835 0H11.2848C11.6627 1.97623e-06 12.0251 0.150137 12.2924 0.417377L18.5826 6.70763C19.1391 7.26412 19.1391 8.16638 18.5826 8.72287Z",
    fill: "url(#paint0_linear_771_8299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_771_8299",
    x1: 9.5,
    y1: 0,
    x2: 9.88,
    y2: 25.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC5A5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.8c881d726bb10186b0422c58e93271f6.svg";
export { ForwardRef as ReactComponent };